const getZeroPaddedRejectCodes = (rejectCodes: string[]): string => {
  return rejectCodes.map(s => s.padStart(3, '0')).join(',')
}

export default getZeroPaddedRejectCodes
